<div [id]="idModal" aria-hidden="true" class="c-modal">
  <div tabindex="-1" data-micromodal-close class="c-modal_overlay">
    <div
      role="dialog"
      aria-modal="true"
      class="c-modal_container c-modal_container--info mg-10"
    >
      <button
        [attr.aria-hidden]="true"
        (click)="cancelAndclose()"
        data-micromodal-close
        class="c-modal_close"
        id="close-modal">
        <em class="material-icons notranslate" [attr.aria-hidden]="true"> clear </em>
      </button>

      <div class="c-modal_cont">
        <div class="color-blue-light u-medium font-18 d-flex d-flex--nowrap">
          <app-sample-material-icon [iconName]="'error_outline'" aria-hidden="true">
          </app-sample-material-icon>
          <p id="textDescriptionInfo" class="color-blue-dark mg-lft-10" tabindex="0">{{ textDescription }}</p>
        </div>

        <div *ngIf="!accion" class="c-modal_btns c-modal_btns--abs">
          <a role="button" id="btn-Aceptar-Modal" href="javascript:"
            (click)="confirmationAndclose()"
            class="u-btn u-btn--icon u-btn--yellow font-16"
          >
            Cerrar Diálogo
          </a>
        </div>
        <div *ngIf="accion" class="c-modal_btns c-modal_btns--abs">
          <a role="button"
            appDebounceClick
            id="{{ accion ? accion : 'modal' }}"
            title="{{ title ? title : 'modal' }}"
            (click)="confirmationAndclose()"
            class="u-btn u-btn--icon u-btn--yellow font-16"
          >
            Cerrar Diálogo
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
